import styled from '@emotion/styled'
import {device} from '../../styles/media-queries'

export const HeaderContainer = styled.header`
  width: 100vw;
  max-width: 100vw;
  flex-direction: row-reverse;
  margin-bottom: -18px;
  position: fixed;
  background-color: white;
  height: 64px;
  z-index: 98;
  padding: 0 60px;

  .toggle-button:hover {
    cursor: pointer;
  }
`

export const HeaderContainerKP = styled.header`
  width: 100vw;
  max-width: 100vw;
  // flex-direction: row-reverse;
  // margin-bottom: -18px;
  position: fixed;
  background-color: white;
  height: 64px;
  z-index: 1;
  padding: 0 60px;

  .toggle-button:hover {
    cursor: pointer;
  }
`

export const OldHeaderContainer = styled.header`
  max-width: 100vw;
  @media screen and ${device.tablet} {
    padding: 10px !important;
  }
  @media screen and ${device.mobileL} {
    & .new-order-button {
      margin: 0 2px 0 2px !important;
    }
  }
  @media (max-width: 1230px) {
    .nav-bar-collapse {
      flex-basis: auto;
      flex-flow: column wrap;
      align-items: center;
    }
    & .nav-item.show {
      margin-top: -20px;
    }
    & .menu-item {
      margin-top: 15px;
    }
  }
  & img,
  .headerdiv {
    max-height: 100px;
  }
  @media print {
    display: none !important;
  }
`

export const HeaderDropdown = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  & > div {
    cursor: pointer;
  }
  & .adminLink {
    color: #ff5000;
  }
  & .adminLink:hover {
    text-decoration: underline;
  }
  & .admin-link-kp {
    color: #ff5000;
  }
  & .admin-link-kp:hover {
    text-decoration: none;
  }
  & .profile-dropdown-wrap {
    color: #000000 !important;
    position: relative !important;
  }
  .profile-name-wrap {
    font-family: Poppins, sans-serif !important;
    // margin: 0 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    gap: 6px;
    .profile-initials {
      color: #ffffff;
      // width: 25px;
      // height: 25px;
      background-color: #ff5000;
      // background-color: #e37908;
      // background-color: #bd4a20;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 5px;
    }
    .profile-welcome {
      color: #666666 !important;
    }
    & .profile-name {
      padding: 0;
      font-weight: 400;
    }
    & .pn-admin:hover {
      text-decoration: underline;
    }
  }
  .profile-dp-toggle {
    cursor: pointer;
    width: 14px;
  }
  .profile-logout-btn {
    & .profile-logout-icon {
      width: 20px;
      height: 20px;
      padding: 4px 4px 4px 6px;
      box-sizing: content-box;
    }
    .profile-logout-icon:hover {
      background: #eef0ff;
      border-radius: 4px;
    }
  }
`

export const UserProfileContainer = styled.div`
  position: absolute !important;
  top: 62px;
  right: 40px;
  min-width: 150px;
  border-radius: 10px;
  border: none !important;
  box-shadow: #0000001f 0 1px 3px, #0000003d 0 1px 2px;
  font-size: 14px;
  // padding: 8px 20px;
  background-color: #ffffff;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  & .profile-title-wrap {
    display: flex;
    flex-direction: column;
    .profile-title-initial {
      width: 25px;
      height: 25px;
      background-color: #bd4a20;
      border-radius: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .profile-title-name {
    }
  }
  & .profile-item-wrap {
    display: flex;
    flex-direction: column;
    padding: 8px 0 0;
    .profile-item {
      padding: 2px 20px;
      display: inline-flex;
      justify-content: flex-start;
      align-items: center;
      gap: 8px;
      .profile-item-key {
        font-weight: 500;
        display: inline-flex;
        justify-content: flex-start;
        align-items: center;
        .profile-item-icon {
          padding: 0 5px 0 0;
        }
      }
      .profile-item-value {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        font-weight: 600;
        // .profile-item-roles {
        //   display: flex;
        //   flex-wrap: wrap;
        //   margin: 0 0 5px 5px;
        //   flex-direction: column;
        //   justify-content: flex-start;
        //   align-items: center;
        .profile-item-value-item {
          padding: 5px;
          border-radius: 5px;
          background: #c5ccff4a;
          // // background: #e3e2e2c9;
          // // margin: 0 0 5px 0;
          // width: fit-content;
          // // margin: 0 5px 0 0;
          width: 100%;
          .role-dp-item {
          }
        }
        // }
      }
    }
  }
  & .item-divider {
    border: 1px solid #ecececb8;
    margin: 2px 0 0;
  }
  & .profile-logout-btn {
    // display: flex;
    // justify-content: center;
    // align-items: cenater;
    // width: 100%;
    // padding: 8px 20px;
    // cursor: pointer;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border: none !important;
    border-radius: 0 0 10px 10px;
    background-color: #fff !important;
    color: #1967d2;
    padding: 6px 0;
    font-weight: 500;
  }
`
export const HeaderNavigationMenu = styled.div`
  padding: 25px;
  font-size: 16px;
  align-items: center;
  font-family: Montserrat, sans-serif !important;
  font-weight: 500;
  & nav {
    display: flex;
  }
  & li {
    list-style-type: none;
  }
  .menu-item {
    text-decoration: none !important;
    gap: 4%;
  }
  & .nav-link.menu-item.active {
    position: relative;
  }
  .active {
    color: black !important;
    border-bottom: 4px solid #ff5000;
    border-radius: 2px;
  }
  .menu-item:hover {
    color: black !important;
  }
  & .nav-item.show {
    display: flex;
    position: absolute;
    margin-left: -40px;
  }
  & .nav-item.hide {
    display: none;
  }
`
export const RoleDropdownStyle = styled.div`
  .role-dropdown {
    position: relative;
    width: auto;
    padding: 0 10px;
    // font-family: Inter, sans-serif;
    contain: layout;
  }

  .role-dp-btn-wrap {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .role-dp-btn-label {
    // font-weight: bold;
    font-weight: 600;
    color: #4e4d4d;
  }

  .role-dp-trigger {
    width: auto;
    padding: 8px 10px;
    background: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    color: #ff5000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .role-dp-trigger:hover {
    border-color: #999;
  }

  .role-arrow {
    font-size: 12px;
    opacity: 0.6;
  }

  .role-dp-menu {
    position: absolute;
    top: 52px;
    // left: 0;
    left: 54px;
    min-width: 150px;
    width: max-content;
    background: #fff;
    border: 1px solid #e3e5eb;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 6px 0;
    list-style: none;
    z-index: 999;
    will-change: opacity;
    backface-visibility: hidden;
  }

  .role-dp-item {
    padding: 10px 14px;
    cursor: pointer;
    font-size: 16px;
    // color: #333;
    transition: background 0.15s ease;
  }

  .role-dp-item:hover {
    background: #f3f4f6;
  }

  .role-dp-item.active {
    background: #ffdccc7a;
    color: #ff5000;
    // background: #e8ecff;
    // color: #1a3cff;
    font-weight: 500;
  }
`
